import DropDown from "./components/Dropdown.vue";
import Wysiwyg from "./components/Wysiwyg.vue";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("wysiwyg", Wysiwyg);
  }
};

export default GlobalComponents;
